<template>
  <div class="cont" id="cont6">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:35px;width:169px;margin-left:59px;margin-bottom:12px"
        :src="require('@/assets/image/home/home6/img1.png')"
        :fit="fit"
      ></el-image>
      <el-image
        @click="img2Click"
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:22px;width:154px;margin-left:43px;margin-bottom:9px;cursor:pointer"
        :src="require('@/assets/image/home/home6/img2.png')"
        :fit="fit"
      ></el-image>
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
        style="height:21px;width:251px;margin-left:32px;margin-bottom:35px"
        :src="require('@/assets/image/home/home6/img5.png')"
        :fit="fit"
      ></el-image>
      
            
      <router-link :to="{ name: 'ShopMallOnline'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInLeftBig visibilityShow' :'visibilityHide'"
          style="height:29px;width:137px;margin-left:0px;margin-bottom:0px"
          :src="require('@/assets/image/home/home6/img4.png')"
          :fit="fit"
        ></el-image>
      </router-link>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContSix",
  data() {
    return {
      fit: "cover",
      animate: false ,
      screenHeight: window.innerHeight || document.documentElement.clientHeight

    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    var topPos = document.getElementById("cont6").offsetTop;
    if (scrollTop + this.screenHeight > topPos) {
      this.animate = true;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var topPos = document.getElementById("cont6").offsetTop;
      if (scrollTop + this.screenHeight > topPos) {
        this.animate = true;
      }
    } , 
    img2Click(){
      window.open( 'http://onlinesystem.dixcel.cn' , '_blank' )  
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  background: url('~@/assets/image/home/home6/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.inner {
  position: absolute;
  width: 228px;
  height: 164px;
  left: 198px;
  top: 102px;
}
</style>